// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { forwardRef } from 'react';

import { useSlug } from '../hooks/useSlug';
import type { GlobalProps } from '../types';
import { classes } from '../utils';

import styles from './helper.module.css';

export type Props = {
  error?: boolean;
  text?: string;
  variant?: 'default' | 'dark';
} & GlobalProps;
export const HelperText = forwardRef<HTMLDivElement, Props>(function Component(
  props,
  ref
) {
  const { error, text, name = 'helper-text', variant } = props;

  const slug = useSlug(name);

  if (!text) {
    return (
      <div
        ref={ref}
        className={classes([styles.helperText], { ...props })}
        data-component={slug}
      />
    );
  }

  return (
    <div
      ref={ref}
      data-component={slug}
      role={error ? 'alert' : 'status'}
      className={classes(
        [
          styles.helperText,
          {
            [styles.error]: error && variant === 'default',
            [styles.errorDark]: error && variant === 'dark',
          },
        ],
        {
          ...props,
        }
      )}
    >
      {text}
    </div>
  );
});
